<script>
import { ADMIN_BADGES_QUERY } from "@/constants/graphql/badges/badge";
import BadgeCard from "../BadgeCard";
import BadgeDialog from "../BadgeDialog";

export default {
  name: "BadgeListMixin",
  components: {
    BadgeCard,
    BadgeDialog,
  },
  data() {
    return {
      type: null,
      search: [],
      badgeModal: {
        show: false,
        form: {
          id: null,
          title: "",
          description: "",
          image: null,
          imageChanged: false,
          enabled: true,
          sendgridTemplateId: "",
        },
      },
    };
  },
  computed: {
    badges() {
      return this.adminBadges?.filter((badge) => this.search.length == 0 || this.search.includes(badge.id));
    },
  },
  methods: {
    addBadge() {
      let form = {
        id: null,
        title: "",
        description: "",
        image: null,
        imageChanged: false,
        enabled: true,
      };

      this.badgeModal.form = form;
      this.badgeModal.show = true;
    },
    editBadge(badge) {
      let form = {
        id: badge.id,
        title: badge.title,
        description: badge.description,
        image: badge.iconLink,
        imageChanged: false,
        enabled: badge.isEnabled,
        sendgridTemplateId: badge.sendgridTemplateId,
      };

      this.badgeModal.form = form;
      this.badgeModal.show = true;
    },
  },
  apollo: {
    adminBadges: {
      query: ADMIN_BADGES_QUERY,
      variables() {
        return {
          type: this.type,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        data.adminBadges.sort((a, b) => (a.isEnabled < b.isEnabled ? 1 : a.title > b.title ? 1 : -1));

        return data.adminBadges;
      },
      skip() {
        return !this.type;
      }
    },
  },
};
</script>
